import { PropsWithChildren } from 'react';
import s from './InputControl.module.scss';

export default function InputControl({ children }: PropsWithChildren) {
  return <div className={s.wrapper}>{children}</div>;
}
